import COLOR from "../../constants/colors";

const styles = {
  paleBackground: {
    background: COLOR.white,
  },
  greenBackground: {
    background: COLOR.green,
  },
  mainArea: {
    minHeight: "100vh",
    marginTop: 64,
    // marginLeft: 128,
    // marginRight: 128,
  },
  button: {
    marginRight: 16,
    width: "20%",
  },
  icon: {
    marginRight: 32,
  },
  avatarView: {
    minHeight: "50vh",
    background: "white",
  },
};

export default styles;
